import { render, staticRenderFns } from "./FileViewerErapor.vue?vue&type=template&id=f402026a&scoped=true"
import script from "./FileViewerErapor.vue?vue&type=script&lang=js"
export * from "./FileViewerErapor.vue?vue&type=script&lang=js"
import style0 from "./FileViewerErapor.vue?vue&type=style&index=0&id=f402026a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f402026a",
  null
  
)

export default component.exports